import React from 'react';
import { Navbar } from '../components/Navbar';
import { ConsularAffairs } from '../components/ConsularAffairs';
import { Footer } from '../components/Footer';
import { FeedbackPopup } from '../components/FeedbackPopup';
export function ConsularPage() {
  return <div className="font-nunito w-full min-h-screen overflow-x-hidden" data-id="element-3520">
      <Navbar data-id="element-3521" />
      <main data-id="element-3522">
        <ConsularAffairs data-id="element-3523" />
      </main>
      <Footer data-id="element-3524" />
      <FeedbackPopup data-id="element-3525" />
    </div>;
}